<template>
  <div>
    <div class="content" :class="{rows: !expanded}">
      {{ content }}
    </div>
    <div class="openText" v-if="content">
      <span @click="expanded = !expanded" v-if="!expanded">展开</span>
      <span @click="expanded = !expanded" v-else>收起</span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    content: String
  },
  data() {
    return {
      expanded: true
    }
  }
}
</script>
<style lang="scss" scoped>
.rows{
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.content{
  word-break: break-all;
}
.openText{
  color: #407eff;
}
</style>